module.exports = __webpack_require__.p + "cb8bc551b019bfd8a1d7f57a665ecbe8.jpg";